import { render, staticRenderFns } from "./Overviews.vue?vue&type=template&id=bc61e050&"
import script from "./Overviews.vue?vue&type=script&lang=js&"
export * from "./Overviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports